export default "__VITE_ASSET__DTGC3pod__"